import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { northLibertyConfig } from "./data";

export default function NorthLibertyPage() {
  return <CityPageTemplate config={northLibertyConfig} />;
}